import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { getConfig } from '@klpkonsern/appconfig';

import { da } from '../locales/da';
import { en } from '../locales/en';
import { no } from '../locales/no';
import { sv } from '../locales/sv';
import { getEnvironment } from '@klp/utils/helpers';

const resources = {
    en: { translation: en },
    da: { translation: da },
    no: { translation: no },
    sv: { translation: sv },
};

const FALLBACK_LANG = 'no';

const getInitialLanguage = (): string => {
    // In test environment, return default immediately
    if (!window?.location) {
        return FALLBACK_LANG;
    }

    try {
        let langFromStorage = localStorage.getItem('lang');

        // Handle legacy JSON-stringified values (e.g., '"no"' instead of 'no')
        if (langFromStorage) {
            try {
                const parsed = JSON.parse(langFromStorage);
                if (typeof parsed === 'string') {
                    langFromStorage = parsed;
                    // Update to plain string format
                    localStorage.setItem('lang', langFromStorage);
                }
            } catch {
                // Not JSON-stringified, use as-is
            }
        }

        const langFromSettings = getConfig(
            'WEBAPP_APP_DEFAULT_LANGUAGE',
            FALLBACK_LANG,
        );

        const lang = langFromStorage || langFromSettings || FALLBACK_LANG;

        if (langFromStorage === null) {
            localStorage.setItem('lang', lang);
        }
        return typeof lang === 'string' ? lang : FALLBACK_LANG;
    } catch (error) {
        return FALLBACK_LANG;
    }
};

const isDevelopment =
    getEnvironment() === 'development' ||
    getEnvironment() === 'local' ||
    getEnvironment() === 'dev';

i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: FALLBACK_LANG,
    // Development-only: Detect and report missing translation keys
    saveMissing: isDevelopment,
    // Return a visible indicator for missing keys in development
    parseMissingKeyHandler: (key) => {
        // Extract the last part of the key (e.g., 'Title' from 'something.somethingElse.Title')
        const lastPart = key.split('.').pop() || key;

        // In production, just show the last part without warning
        return lastPart;
    },

    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
});

i18n.on('languageChanged', (lng) => {
    localStorage.setItem('lang', lng);
});

export default i18n;
